import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Toast = ({
  variant = 'info',
  width = 'w-[300px]',
  showIcon = true,
  header,
  body,
  onClose,
  children,
  showArrow = false,
  headerClassName = '',
  position = 'bottom-center'
}) => {
  const variantStyles = {
    info: {
      backgroundColor: 'bg-info', borderColor: 'border-info', textColor: 'text-white', fillColor: 'white'
    },
    warning: {
      backgroundColor: 'bg-warning', borderColor: 'border-warning', textColor: 'text-black', fillColor: 'black'
    },
    alert: {
      backgroundColor: 'bg-alert', borderColor: 'border-alert', textColor: 'text-white', fillColor: 'white'
    },
    success: {
      backgroundColor: 'bg-success', borderColor: 'border-success', textColor: 'text-white', fillColor: 'white'
    },
    notification: {
      backgroundColor: 'bg-white dark:bg-grey-800', borderColor: 'border-white dark:border-grey-800', textColor: 'text-black dark:text-grey-200', fillColor: 'black dark:text-grey-200', boxShadow: 'shadow-lg'
    },
  };

  const style = variantStyles[variant];

  const icons = {
    info: <InfoRoundedIcon sx={{ color: `${style.fillColor}` }} fontSize='small' />,
    warning: <ErrorIcon sx={{ color: `${style.fillColor}` }} fontSize='small' />,
    alert: <ErrorIcon sx={{ color: `${style.fillColor}` }} fontSize='small' />,
    success: <CheckCircleIcon sx={{ color: `${style.fillColor}` }} fontSize='small' />,
    notification: <InfoRoundedIcon sx={{ color: `${style.fillColor}` }} fontSize='small' />
  };

  const positionStyles = {
    'bottom-center': 'left-1/2',
    'bottom-left': 'left-[20px]',
    'bottom-right': 'right-[20px]',
  };

  return (
    <div className={`${width} ${showIcon ? 'p-2' : 'p-3'} ${style.backgroundColor} rounded-md border ${style.borderColor} flex`}>
      <div className='w-full flex flex-col'>
        <div className='w-full justify-between flex'>
          <div className='w-full justify-start items-center gap-2 flex'>
            {showIcon && icons[variant]}
            <div className={`${style.textColor} text-sm leading-5 ${showIcon ? 'font-normal' : 'font-bold'} ${headerClassName}`}>{header}</div>
          </div>
          {!!onClose && <CloseIcon onClick={onClose} sx={{ color: `${style.fillColor}`, cursor: 'pointer' }} fontSize='small' />}
        </div>
        <div className={`flex flex-col ${showIcon && 'px-[28px]'}`}>
          <div className={`text-sm leading-5 font-normal pt-2 ${style.textColor}`}>{body}</div>
          {!!children && <div className='pt-4'>{children}</div>}
        </div>

      </div>
      {showArrow && <div className={`absolute -bottom-1 ${positionStyles[position]}  transform -translate-x-1/2`}>
        <div className={`w-2 h-2 ${style.backgroundColor}  left-0 bottom-0 transform rotate-45`}></div>
      </div>}
    </div>
  );
};

Toast.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'alert', 'success', 'notification']),
  header: PropTypes.string.isRequired,
  body: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node
};

export default Toast;
